import React, { Component } from "react";
import { CRUDFunction } from "../../reduxCURD/container";
import SpinnerLoader from "../Common/SpinnerLoader";
import { languageService } from "../../Language/language.service";
import Icon from "react-icons-kit";
import { checkboxUnchecked } from "react-icons-kit/icomoon/checkboxUnchecked";
import { checkboxChecked } from "react-icons-kit/icomoon/checkboxChecked";
import _ from "lodash";
import { MyButton } from "../Common/Forms/formsMiscItems";
import "./style.css";
import moment from "moment";
import { DateField } from "../SetupPage/GITestAssetTypes/AddTestsForm";
import { formFeildStyle } from "../../wigets/forms/style/formFields";
import { themeService } from "../../theme/service/activeTheme.service";
import { findTreeNode, filterTreeByProperties } from "../../utils/treeData";
import { curdActions } from "reduxCURD/actions";

class AssetTests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      assetTree: null,
      origAssetTestList: [],
      assetTestList: [],
      testName: "",
      locations: [],
      location: "All",
    };
    this.onTestClick = this.onTestClick.bind(this);
    this.handleSaveUpdates = this.handleSaveUpdates.bind(this);
    this.LocationSelect = this.LocationSelect.bind(this);
    this.onToggleSelectAll = this.onToggleSelectAll.bind(this);
    this.computeSelectAll = this.computeSelectAll.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.createMode) {
      this.props.getAsset("/getAssetTree");
      this.setState({ testName: this.props.testName });
    } else {
      let aType = this.props.assetType && this.props.assetType.assetType;
      let testCode = this.props.testCode && this.props.testCode.code;
      let arg = `aTypeFreqTests/?aType=${aType}&testCode=${testCode}`;
      let testDetail = this.props.testCode.opt2.config.find((name) => {
        if (name.assetType === aType) return true;
      });
      this.setState({ testName: testDetail.name });
      this.props.getAssetTests(arg);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.actionType !== prevProps.actionType && this.props.actionType === "ASSETTESTS_READ_REQUEST") {
      this.setState({
        loader: true,
      });
    }

    if (this.props.actionType !== prevProps.actionType && this.props.actionType === "ASSETTESTS_READ_SUCCESS") {
      this.setState({
        loader: false,
        origAssetTestList: _.cloneDeep(this.props.assetTests),
        assetTestList: _.cloneDeep(this.props.assetTests),
      });
    }
    if (this.props.actionType !== prevProps.actionType && this.props.actionType === "ASSETTESTS_READ_FAILURE") {
      this.setState({
        loader: false,
      });
    }

    if (this.props.assetActionType !== prevProps.assetActionType && this.props.assetActionType === "ASSET_READ_SUCCESS") {
      let assetTree = this.props.asset;
      if (assetTree) this.loadAssets(assetTree.assetsTreeObj);
    }
  }

  loadAssets(assetTree) {
    let assetsByProperties = [];
    let locations = [];
    filterTreeByProperties(assetTree, { assetType: this.props.assetType && this.props.assetType.assetType }, assetsByProperties, true);
    filterTreeByProperties(assetTree, { location: true, plannable: true }, locations, true);

    let assetsList = assetsByProperties.map((assetWithId) => ({
      id: assetWithId.id,
      unitId: assetWithId.properties.unitId,
      assetType: assetWithId.properties.assetType,
      disabled: false,
      firstDate: this.props.startDate,
    }));
    this.setState({
      assetTree: assetTree,
      origAssetTestList: this.props.assetsList ? this.props.assetsList : assetsList,
      assetTestList: this.props.assetsList ? this.props.assetsList : assetsList,
      locations: locations,
    });
    this.props.setLocationOptions && this.props.setLocationOptions(locations);
  }

  computeSelectAll(assetTestList) {
    return assetTestList.filter((assetTest) => !assetTest.disabled).length === assetTestList.length;
  }

  getAssetTestIdProp() {
    const { createMode } = this.props;
    return createMode ? "id" : "_id";
  }

  onTestClick(assetTest) {
    let assetTestList = [...this.state.assetTestList];
    let testIndex = _.findIndex(assetTestList, { [this.getAssetTestIdProp()]: assetTest[this.getAssetTestIdProp()] });
    if (testIndex > -1) {
      assetTestList[testIndex] = { ...assetTestList[testIndex], ...{ disabled: !assetTestList[testIndex].disabled } };
      this.setState({
        assetTestList: assetTestList,
      });
    }
  }
  onChange(assetTest, field, value) {
    let assetTestList = [...this.state.assetTestList];
    let aTestIndex = assetTestList.findIndex((asset) => asset[this.getAssetTestIdProp()] === assetTest[this.getAssetTestIdProp()]);
    if (aTestIndex > -1) {
      assetTestList[aTestIndex] = { ...assetTestList[aTestIndex], [field]: value };
    }
    this.setState({
      assetTestList: assetTestList,
      listChanged: true,
    });
  }
  onToggleSelectAll() {
    let { assetTestList } = this.state;
    const selectAll = this.computeSelectAll(this.state.assetTestList);

    assetTestList = assetTestList.map((assetTest) => {
      return { ...assetTest, ...{ disabled: selectAll } };
    });
    this.setState({
      assetTestList: assetTestList,
    });
  }
  handleSaveUpdates() {
    const { updateAssetTest, setAssetsConfigLIst, createMode } = this.props;
    const { assetTestList } = this.state;
    this.setState({ origAssetTestList: assetTestList });
    createMode ? setAssetsConfigLIst(assetTestList) : updateAssetTest(this.getAssetTestListChange(), "disableMulti");
  }
  LocationSelect(loc) {
    this.setState({
      location: loc,
    });
  }

  getAssetTestListChange() {
    const { assetTestList, origAssetTestList } = this.state;
    return assetTestList
      .filter((assetTest, index) => {
        const prevAssetTest = origAssetTestList[index];
        return prevAssetTest.disabled !== assetTest.disabled;
      })
      .map((assetTest) => _.pick(assetTest, [this.getAssetTestIdProp(), "disabled"]));
  }

  isUpdateRequired() {
    const { assetTestList, origAssetTestList } = this.state;
    return assetTestList.find((assetTest, index) => {
      const prevAssetTest = origAssetTestList[index];
      return prevAssetTest.disabled !== assetTest.disabled || prevAssetTest.firstDate !== assetTest.firstDate;
    })
      ? true
      : false;
  }

  getFilteredAssetTestList() {
    const { location, assetTestList, assetTree } = this.state;

    let locTreeBranch = assetTree ? findTreeNode(assetTree, location) : null;
    return location === "All" || !locTreeBranch
      ? assetTestList
      : assetTestList.filter((assetTest) => {
          return findTreeNode(locTreeBranch, assetTest[this.getAssetTestIdProp()]);
        });
  }

  render() {
    const { assetTestList } = this.state;
    const { createMode } = this.props;

    const selectAll = this.computeSelectAll(assetTestList);
    const filteredAssetTestList = createMode ? this.getFilteredAssetTestList() : assetTestList;
    return (
      <div>
        <SpinnerLoader loading={this.state.loader} />{" "}
        <ListHeading
          listChanged={this.isUpdateRequired()}
          handleSaveUpdates={this.handleSaveUpdates}
          name={this.state.testName}
          buttonName={createMode ? languageService("Set Assets Config") : languageService("Update Assets Config")}
        />
        {createMode ? (
          <div className="dropdown-assets">
            <label className="location-title" style={{ marginRight: "10px" }}>
              {" "}
              {languageService("Location")} :{" "}
            </label>
            <LocationFilter locations={this.state.locations} selectedLocation={this.state.location} LocationSelect={this.LocationSelect} />
          </div>
        ) : null}
        <InfoArea
          aType={this.props.assetType && this.props.assetType.assetType}
          testDescription={this.props.testCode && this.props.testCode.description}
        />
        <ul className="list-asset-test scrollbar">
          <AssetsList
            assetTestList={filteredAssetTestList}
            onTestClick={this.onTestClick}
            selectAll={selectAll}
            onToggleSelectAll={this.onToggleSelectAll}
            createMode={this.props.createMode}
            onChange={this.onChange}
          />
        </ul>
      </div>
    );
  }
}

const getAsset = curdActions.getAsset;
let actionOptions = {
  read: true,
  create: true,
  update: true,
  delete: false,
  others: { getAsset },
};
let variableOptions = {
  assetReducer: {
    asset: null,
  },
};
let cReducers = ["assetReducer"];

const AssetTestContainer = CRUDFunction(AssetTests, "assetTest", actionOptions, variableOptions, cReducers);
export default AssetTestContainer;

// same
export const ListHeading = (props) => {
  return (
    <h5 className="area-update-asset">
      <span className="title-update-asset">{languageService(props.name)}</span>
      {props.listChanged && (
        <span className="btn-update-asset">
          <MyButton
            onClick={(e) => {
              props.handleSaveUpdates();
            }}
          >
            {languageService(props.buttonName ? props.buttonName : "Update Assets Config")}
          </MyButton>
        </span>
      )}
    </h5>
  );
};

// same
export const InfoArea = (props) => {
  return (
    <div className="info-area">
      <label className="asset-title"> {languageService("Asset")}</label>
      <label className="start-sate title"> {languageService("Schedule Start Date")}</label>
      <div className="info-labels">
        <label>{languageService("Asset Type")}</label> : <span>{props.aType}</span>
      </div>
      {props.testDescription && (
        <div className="info-labels-full">
          <label> {languageService("Form Name")}</label> :<span> {props.testDescription}</span>
        </div>
      )}
    </div>
  );
};

export const AssetsList = ({ assetTestList, onTestClick, selectAll, onToggleSelectAll, createMode, onChange }) => {
  let mapList = [];
  if (assetTestList && assetTestList.length > 0) {
    mapList = assetTestList.map((assetTest, index) => {
      return (
        <AssetTestItem key={`ati-${index}`} assetTest={assetTest} onTestClick={onTestClick} createMode={createMode} onChange={onChange} />
      );
    });
  }
  return [<SelectAllAssetItem key={"select-all-assets"} selectAll={selectAll} onToggleSelectAll={onToggleSelectAll} />, ...mapList];
};

export const SelectAllAssetItem = ({ selectAll, onToggleSelectAll }) => {
  return (
    <li style={{ position: "sticky", top: 0, backgroundColor: "rgb(229 239 223)", borderRadius: "0px" }}>
      <span className="asset-check-box" onClick={(e) => onToggleSelectAll()}>
        <Icon icon={selectAll ? checkboxChecked : checkboxUnchecked} size={20} />
      </span>
      <span className="asset-test-name" style={{ fontWeight: 600 }}>
        {languageService("Select all")}
      </span>
      <span className="asset-test-date"></span>
    </li>
  );
};

export const AssetTestItem = ({ assetTest, onTestClick, createMode, onChange }) => {
  let toRet = null;
  if (assetTest) {
    let assetName = createMode ? assetTest.unitId : assetTest.assets && assetTest.assets[0] ? assetTest.assets[0].unitId : "";

    toRet = (
      <li key={assetName} className="item">
        <span className="asset-check-box" onClick={(e) => onTestClick(assetTest)}>
          <Icon icon={assetTest.disabled ? checkboxUnchecked : checkboxChecked} size={20} />
        </span>
        <span className="asset-test-name">{assetName}</span>
        {createMode ? (
          <DateField
            inputFieldProps={{ name: "firstDate" }}
            changeHandler={(e) => onChange(assetTest, "firstDate", e.target.value)}
            value={assetTest.firstDate}
            style={{ backgroundColor: "transparent" }}
          />
        ) : (
          <span className="asset-test-date">{assetTest.startDate ? moment(assetTest.startDate).format("MM-DD-YYYY") : ""}</span>
        )}
      </li>
    );
  }
  return toRet;
};
export const CheckBoxFieldCustom = (props) => {
  return (
    <div>
      <span onClick={(e) => props.onChangeHandler({ target: { name: props.name, value: !props.value } })}>
        <Icon icon={props.value ? checkboxChecked : checkboxUnchecked} size={20} />
      </span>
      <label style={{ ...themeService(formFeildStyle.lblStyle), width: "inherit", margin: "0px 5px 5px" }}>
        {languageService(props.label)}
      </label>
    </div>
  );
};
const LocationFilter = (props) => {
  let locOpts =
    props.locations &&
    props.locations.map((location) => {
      return <option value={location.id}>{location.properties.unitId}</option>;
    });
  locOpts = [<option value={"All"}>{"All"}</option>, ...locOpts];
  return (
    <select
      style={{ ...themeService(formFeildStyle.inputStyle), minWidth: "250px", borderWidth: "2px" }}
      onChange={(e) => props.LocationSelect(e.target.value)}
      value={props.location}
    >
      {locOpts}
    </select>
  );
};



// WEBPACK FOOTER //
// ./src/components/AssetTests/AssetTests.jsx